import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Card, CardBody, CardHeader, Button } from "reactstrap";
import ImageCropModal from "./ImageCropModal";
// import ImageCropModal from './ImageCropModal';

const FileDropzone = ({
  selectedFiles,
  setSelectedFiles,
  existingImage = null,
  customStyles = {},
}) => {
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [imageToCrop, setImageToCrop] = useState(null);

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      const reader = new FileReader();

      reader.onload = () => {
        setImageToCrop(reader.result);
        setCropModalOpen(true);
      };

      reader.readAsDataURL(file);
    }
  }, []);

  const handleCropComplete = (croppedImage) => {
    setSelectedFiles([
      {
        isExisting: false,
        preview: croppedImage.url,
        payload: croppedImage.file,
      },
    ]);
    setImageToCrop(null);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [".png", ".jpg", ".jpeg", ".gif", ".webp"],
    },
    maxFiles: 1,
    multiple: false,
  });

  const handleRemoveFile = (e) => {
    e.stopPropagation();
    setSelectedFiles([]);
  };

  return (
    <>
      <div>
        {selectedFiles.length === 0 ? (
          <div
            {...getRootProps()}
            style={{
              border: customStyles.dropzone?.border || "2px dashed #dee2e6",
              borderRadius: customStyles.dropzone?.borderRadius || "8px",
              padding: customStyles.dropzone?.padding || "40px 20px",
              textAlign: customStyles.dropzone?.textAlign || "center",
              backgroundColor: isDragActive
                ? "#e7f3ff"
                : customStyles.dropzone?.backgroundColor || "#f8f9fa",
              cursor: customStyles.dropzone?.cursor || "pointer",
              transition: "all 0.3s ease",
            }}
          >
            <input {...getInputProps()} />
            <i
              className="ri-image-add-line"
              style={
                customStyles.icon || {
                  fontSize: "48px",
                  color: "#adb5bd",
                  marginBottom: "12px",
                  display: "block",
                }
              }
            ></i>
            <h6
              style={
                customStyles.title || {
                  margin: "0 0 8px 0",
                  color: "#495057",
                  fontSize: "14px",
                  fontWeight: 500,
                }
              }
            >
              {isDragActive
                ? "Drop image here"
                : "Drop image here or click to browse"}
            </h6>
            <p
              style={
                customStyles.subtitle || {
                  margin: 0,
                  color: "#6c757d",
                  fontSize: "12px",
                }
              }
            >
              Supports: PNG, JPG, JPEG, GIF, WEBP
            </p>
          </div>
        ) : (
          <div style={{ position: "relative" }}>
            <div
              style={{
                width: "100%",
                height: "300px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px",
                overflow: "hidden",
                border: "1px solid #dee2e6",
              }}
            >
              <img
                src={selectedFiles[0].preview}
                alt="Product"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
            <Button
              color="danger"
              size="sm"
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                borderRadius: "50%",
                width: "32px",
                height: "32px",
                padding: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={handleRemoveFile}
            >
              <i className="ri-close-line" style={{ fontSize: "16px" }}></i>
            </Button>
            <div style={{ marginTop: "12px", textAlign: "center" }}>
              <Button
                color="primary"
                size="sm"
                onClick={() => {
                  const input = document.createElement("input");
                  input.type = "file";
                  input.accept = "image/*";
                  input.onchange = (e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const reader = new FileReader();
                      reader.onload = () => {
                        setImageToCrop(reader.result);
                        setCropModalOpen(true);
                      };
                      reader.readAsDataURL(file);
                    }
                  };
                  input.click();
                }}
              >
                <i className="ri-crop-line" style={{ marginRight: "6px" }}></i>
                Change Image
              </Button>
            </div>
          </div>
        )}
      </div>

      <ImageCropModal
        isOpen={cropModalOpen}
        toggle={() => {
          setCropModalOpen(false);
          setImageToCrop(null);
        }}
        imageSrc={imageToCrop}
        onCropComplete={handleCropComplete}
        aspectRatio={1}
      />
    </>
  );
};

export default FileDropzone;
